import { siteMetadata } from "./metaTags";

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": siteMetadata.title,
  "alternateName": ["Marriage Biodata Creator", "Free Biodata Maker", "Online Biodata Generator"],
  "url": siteMetadata.siteUrl,
  "description": siteMetadata.description,
  "potentialAction": [
    {
      "@type": "SearchAction",
      "target": "https://biodata360.in/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    },
    {
      "@type": "CreateAction",
      "target": "https://biodata360.in/create",
      "name": "Create Marriage Biodata"
    }
  ],
  "publisher": {
    "@type": "Organization",
    "name": siteMetadata.title,
    "url": siteMetadata.siteUrl,
    "logo": {
      "@type": "ImageObject",
      "url": siteMetadata.image,
    }
  },
  "mainEntity": {
    "@type": "WebApplication",
    "name": "Marriage Biodata Maker",
    "applicationCategory": "DesignApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    }
  }
};

export const howToSchema = {
  "@context": "https://schema.org",
  "@type": "HowTo",
  "name": "How to Create Marriage Biodata Online",
  "description": "Step-by-step guide to create professional marriage biodata using our free online tool",
  "image": "https://biodata360.in/Media/Website Images/Main Biodata360 Logo.png",
  "totalTime": "PT10M",
  "estimatedCost": {
    "@type": "MonetaryAmount",
    "currency": "USD",
    "value": "0"
  },
  "supply": [
    {
      "@type": "HowToSupply",
      "name": "Personal Details"
    },
    {
      "@type": "HowToSupply",
      "name": "Professional Photo"
    },
    {
      "@type": "HowToSupply",
      "name": "Family Details"
    }
  ],
  "tool": [
    {
      "@type": "HowToTool",
      "name": "Biodata360 Online Tool"
    }
  ],
  "step": [
    {
      "@type": "HowToStep",
      "name": "Enter Personal Details",
      "text": "Fill in your basic information including name, age, education, and occupation",
      "url": "https://biodata360.in/create",
      "image": "https://biodata360.in/Media/Website Images/Main Biodata360 Logo.png"
    },
    {
      "@type": "HowToStep",
      "name": "Upload Photo",
      "text": "Add your professional photo for the biodata",
      "url": "https://biodata360.in/create",
      "image": "https://biodata360.in/Media/Website Images/Main Biodata360 Logo.png"
    },
    {
      "@type": "HowToStep",
      "name": "Add Family Information",
      "text": "Include family details and background information",
      "url": "https://biodata360.in/create",
      "image": "https://biodata360.in/Media/Website Images/Main Biodata360 Logo.png"
    },
    {
      "@type": "HowToStep",
      "name": "Choose Template",
      "text": "Select from our professional biodata templates",
      "url": "https://biodata360.in/create",
      "image": "https://biodata360.in/Media/Website Images/Main Biodata360 Logo.png"
    },
    {
      "@type": "HowToStep",
      "name": "Download PDF",
      "text": "Generate and download your completed marriage biodata as PDF",
      "url": "https://biodata360.in/create",
      "image": "https://biodata360.in/Media/Website Images/Main Biodata360 Logo.png"
    }
  ]
};

export const webApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "WebApplication",
  "name": "Biodata360",
  "alternateName": ["Marriage Biodata Maker", "Biodata Creator", "Marriage Biodata Creator", "Free Biodata Maker", "Online Biodata Generator"],
  "description": "Create beautiful marriage biodata online with professional templates. Free, no registration required, instant PDF download. Perfect for Indian matrimonial profiles with 50+ templates.",
  "url": "https://biodata360.in",
  "applicationCategory": "DesignApplication",
  "operatingSystem": "Web Browser",
  "browserRequirements": "Requires JavaScript. Requires HTML5.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "5247",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD",
    "availability": "https://schema.org/InStock",
    "validFrom": "2024-01-01"
  },
  "featureList": [
    "50+ Professional marriage biodata templates",
    "Real-time biodata preview with live editing",
    "Instant PDF download in high quality",
    "No registration or signup required",
    "Multiple language support (Hindi, Marathi, English)",
    "AI-powered background remover tool for photos",
    "Custom fields and personalization options",
    "Mobile-friendly responsive design",
    "Completely free to use forever",
    "Traditional and modern biodata formats",
    "Photo cropping and editing tools",
    "Print-ready PDF generation"
  ],
  "screenshot": "https://biodata360.in/Media/Website Images/Main Biodata360 Logo.png",
  "softwareVersion": "2.0",
  "dateCreated": "2024-01-01",
  "dateModified": "2024-12-28",
  "author": {
    "@type": "Organization",
    "name": "Biodata360",
    "url": "https://biodata360.in"
  },
  "provider": {
    "@type": "Organization",
    "name": "Biodata360",
    "url": "https://biodata360.in"
  },
  "audience": [
    {
      "@type": "Audience",
      "audienceType": "People looking for marriage",
      "geographicArea": "India"
    },
    {
      "@type": "Audience",
      "audienceType": "Parents seeking matrimonial matches",
      "geographicArea": "India"
    }
  ],
  "keywords": "marriage biodata maker, free biodata creator, online biodata generator, matrimonial profile maker"
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Biodata360",
  "alternateName": ["Marriage Biodata Creator", "Free Biodata Maker", "Online Biodata Generator"],
  "description": "Leading online platform for creating professional marriage biodatas with beautiful templates and instant PDF download. Trusted by thousands of users worldwide.",
  "url": siteMetadata.siteUrl,
  "logo": {
    "@type": "ImageObject",
    "url": siteMetadata.image,
    "width": "400",
    "height": "400"
  },
  "foundingDate": "2024-01-01",
  "founder": {
    "@type": "Person",
    "name": "Dr. Satyam Chavan"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91-XXXXXXXXXX",
    "contactType": "customer service",
    "email": "support@biodata360.in",
    "availableLanguage": ["English", "Hindi", "Marathi"]
  },
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN",
    "addressRegion": "India"
  },
  "serviceArea": {
    "@type": "Place",
    "name": "Worldwide"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Biodata Templates and Tools",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Free Marriage Biodata Templates",
          "description": "50+ professional marriage biodata templates available for free download"
        },
        "price": "0",
        "priceCurrency": "USD"
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "AI Background Remover Tool",
          "description": "Advanced AI-powered background removal for biodata photos"
        },
        "price": "0",
        "priceCurrency": "USD"
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Partner Compatibility Calculator",
          "description": "Astrological compatibility analysis for marriage partners"
        },
        "price": "0",
        "priceCurrency": "USD"
      }
    ]
  },
  "sameAs": [
    "https://facebook.com/biodata360",
    "https://twitter.com/biodata360",
    "https://instagram.com/biodata360",
    "https://linkedin.com/company/biodata360",
    "https://youtube.com/channel/biodata360"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "5247",
    "bestRating": "5",
    "worstRating": "1"
  }
};

export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Marriage Biodata Creation Service",
  "description": "Professional marriage biodata creation service with customizable templates, real-time preview, and instant PDF download.",
  "provider": {
    "@type": "Organization",
    "name": "Biodata360"
  },
  "areaServed": "Worldwide",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Biodata Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Marriage Biodata Creator",
          "description": "Create professional marriage biodatas with multiple templates"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Photo Background Remover",
          "description": "Remove backgrounds from photos for better biodata presentation"
        }
      }
    ]
  },
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD",
    "availability": "https://schema.org/InStock"
  }
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How to create a marriage biodata online?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can create a marriage biodata online using Biodata360 by filling in your personal details, selecting a template, and downloading the PDF instantly. No registration required. Simply visit our biodata creator tool, enter your information step by step, and generate your professional marriage biodata."
      }
    },
    {
      "@type": "Question",
      "name": "Is the biodata maker free to use?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Biodata360 is completely free to use. You can create unlimited marriage biodatas without any charges or registration. All our biodata templates and tools are available at no cost."
      }
    },
    {
      "@type": "Question",
      "name": "What marriage biodata formats are available?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We offer multiple professional marriage biodata templates in PDF format that you can download instantly after creation. Our templates include traditional and modern designs suitable for different preferences and communities."
      }
    },
    {
      "@type": "Question",
      "name": "Can I create biodata in different languages?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, our platform supports multiple languages including English, Hindi, Marathi, and other Indian languages for creating marriage biodatas. You can create biodata in your preferred language."
      }
    },
    {
      "@type": "Question",
      "name": "How to make biodata for marriage with photo?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "To make biodata for marriage with photo, use our biodata creator tool, fill in your details, upload your photo in the photo section, and download your completed biodata. We also provide a background remover tool to enhance your photo."
      }
    },
    {
      "@type": "Question",
      "name": "What information should be included in marriage biodata?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A marriage biodata should include personal details (name, age, height, education, occupation), family information (parents' details, siblings), contact information, and a professional photo. Our guided form helps you include all necessary information."
      }
    }
  ]
};

export const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://biodata360.in"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Create Marriage Biodata",
      "item": "https://biodata360.in/create"
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": "Biodata Tools",
      "item": "https://biodata360.in/tools"
    },
    {
      "@type": "ListItem",
      "position": 4,
      "name": "Marriage Biodata Guide",
      "item": "https://biodata360.in/blog"
    }
  ]
};

// Breadcrumb Schema Generator
export const generateBreadcrumbSchema = (crumbs: { name: string; url: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": crumbs.map((crumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": crumb.name,
    "item": `${siteMetadata.siteUrl}${crumb.url}`,
  })),
});

// Article Schema Generator
export const generateArticleSchema = (article: {
  headline: string;
  image: string;
  datePublished: string;
  dateModified: string;
  authorName: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": article.headline,
  "image": article.image,
  "datePublished": article.datePublished,
  "dateModified": article.dateModified,
  "author": {
    "@type": "Person",
    "name": article.authorName,
  },
  "publisher": {
    "@type": "Organization",
    "name": siteMetadata.title,
    "logo": {
      "@type": "ImageObject",
      "url": siteMetadata.image,
    },
  },
});

// FAQ Schema Generator
export const generateFaqSchema = (faqs: { question: string; answer: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer,
    },
  })),
});

// Person Schema Generator
export const generatePersonSchema = (author: {
  name: string;
  url: string;
  image: string;
  jobTitle: string;
  sameAs: string[];
}) => ({
  "@context": "https://schema.org",
  "@type": "Person",
  "name": author.name,
  "url": author.url,
  "image": author.image,
  "jobTitle": author.jobTitle,
  "worksFor": {
    "@type": "Organization",
    "name": siteMetadata.title,
  },
  "sameAs": author.sameAs,
});
